import { render, staticRenderFns } from "./schoolData_teaUse.vue?vue&type=template&id=27fb3b7e&scoped=true&"
import script from "./schoolData_teaUse.vue?vue&type=script&lang=js&"
export * from "./schoolData_teaUse.vue?vue&type=script&lang=js&"
import style0 from "./schoolData_teaUse.vue?vue&type=style&index=0&id=27fb3b7e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fb3b7e",
  null
  
)

export default component.exports